// src/hooks/useApi.js
import axios from 'axios';

const API = axios.create({ baseURL: "https://nirmalram-construction-server.vercel.app/api" });

API.interceptors.request.use(config => {
  const token = localStorage.getItem('nr_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const api = {
  // Auth
  login: (data) => API.post('/auth/login', data),
  getMe: () => API.get('/auth/me'),
  changePassword: (data) => API.put('/auth/password', data),

  // Projects
  getProjects: (params) => API.get('/projects', { params }),
  getProject: (id) => API.get(`/projects/${id}`),
  createProject: (data) => API.post('/projects', data, { headers: { 'Content-Type': 'multipart/form-data' } }),
  updateProject: (id, data) => API.put(`/projects/${id}`, data, { headers: { 'Content-Type': 'multipart/form-data' } }),
  deleteProject: (id) => API.delete(`/projects/${id}`),

  // Feedback
  getFeedback: () => API.get('/feedback'),
  getAllFeedback: () => API.get('/feedback/all'),
  submitFeedback: (data) => API.post('/feedback', data),
  updateFeedback: (id, data) => API.put(`/feedback/${id}`, data),
  deleteFeedback: (id) => API.delete(`/feedback/${id}`),

  // Enquiries
  submitEnquiry: (data) => API.post('/enquiries', data),
  getEnquiries: () => API.get('/enquiries'),
  updateEnquiry: (id, data) => API.put(`/enquiries/${id}`, data),
  deleteEnquiry: (id) => API.delete(`/enquiries/${id}`),

  // Videos
  getVideos: () => API.get('/videos'),
  uploadVideo: (data) => API.post('/videos', data, { headers: { 'Content-Type': 'multipart/form-data' } }),
  deleteVideo: (id) => API.delete(`/videos/${id}`),
};

console.log("API URL:", import.meta.env.VITE_API_URL);

export default api;

